import { useState } from "react";
import { KeyRound, Loader2, Eye, EyeOff, ShieldCheck } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { setToken } from "@/lib/authStorage";
import { toast } from "sonner";

const inputCls = "w-full mt-1 border border-slate-300 px-3 py-2.5 text-sm focus:outline-none focus:border-orange-500 pr-10";

export function ChangePassword() {
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [show, setShow] = useState(false);
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password.length < 6) { toast.error("Parola nouă trebuie să aibă minim 6 caractere."); return; }
    if (form.new_password !== form.confirm) { toast.error("Parolele nu coincid."); return; }
    setSaving(true);
    try {
      const { data } = await api.post("/auth/change-password", {
        current_password: form.current_password,
        new_password: form.new_password,
      });
      if (data?.token) setToken(data.token);
      toast.success("Parola a fost schimbată cu succes.");
      setForm({ current_password: "", new_password: "", confirm: "" });
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail));
    } finally { setSaving(false); }
  };

  return (
    <div className="border border-slate-200 bg-white p-6 mt-8" data-testid="change-password-panel">
      <div className="flex items-center gap-2 font-black text-slate-900 mb-1">
        <KeyRound className="w-5 h-5 text-orange-600" /> Schimbă parola
      </div>
      <p className="text-sm text-slate-500 mb-5 flex items-center gap-1.5">
        <ShieldCheck className="w-4 h-4 text-emerald-600" /> Folosește o parolă puternică și unică pentru contul tău.
      </p>
      <form onSubmit={submit} className="grid gap-4 max-w-md">
        <div>
          <label className="text-xs uppercase tracking-wide font-bold text-slate-500">Parola curentă</label>
          <div className="relative">
            <input
              type={show ? "text" : "password"}
              value={form.current_password}
              onChange={(e) => setForm({ ...form, current_password: e.target.value })}
              autoComplete="current-password"
              className={inputCls}
              data-testid="cp-current"
            />
          </div>
        </div>
        <div>
          <label className="text-xs uppercase tracking-wide font-bold text-slate-500">Parola nouă</label>
          <div className="relative">
            <input
              type={show ? "text" : "password"}
              value={form.new_password}
              onChange={(e) => setForm({ ...form, new_password: e.target.value })}
              autoComplete="new-password"
              className={inputCls}
              data-testid="cp-new"
            />
            <button type="button" onClick={() => setShow((s) => !s)} className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-700" aria-label="Arată parola" data-testid="cp-toggle">
              {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
            </button>
          </div>
        </div>
        <div>
          <label className="text-xs uppercase tracking-wide font-bold text-slate-500">Confirmă parola nouă</label>
          <input
            type={show ? "text" : "password"}
            value={form.confirm}
            onChange={(e) => setForm({ ...form, confirm: e.target.value })}
            autoComplete="new-password"
            className={inputCls}
            data-testid="cp-confirm"
          />
        </div>
        <div>
          <button
            type="submit"
            disabled={saving || !form.new_password || !form.confirm}
            className="inline-flex items-center gap-2 bg-slate-900 hover:bg-slate-800 disabled:opacity-50 text-white px-5 py-2.5 text-sm font-bold uppercase tracking-wide transition-colors"
            data-testid="cp-submit"
          >
            {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <KeyRound className="w-4 h-4" />} Schimbă parola
          </button>
        </div>
      </form>
    </div>
  );
}
